// Independent providers: facilities that registered themselves, outside any agency (backend app/Independent/CLAUDE.md).
// Sign-in returns `independent` (null for everyone else); it is kept in localStorage like `user` and `agency`.
// For these facilities `agency` is the facility itself, so agency-scoped pages use their own price list and patients.

export function independent() {
  try {
    return JSON.parse(localStorage.getItem("independent") || "null");
  } catch (e) {
    return null;
  }
}

export function isIndependent() {
  return !!independent();
}

export function isApprovedIndependent() {
  const row = independent();
  return !!row && row.status === "approved";
}

export function saveIndependent(summary) {
  try {
    localStorage.setItem("independent", JSON.stringify(summary || null));
  } catch (e) {
    // storage unavailable: pages fall back to treating the user as an agency facility
  }
}

/** Reloads the summary (status may have changed since sign-in). Resolves to the summary or null. */
export function refreshIndependent(axios) {
  if (!isIndependent()) return Promise.resolve(null);
  return axios
    .get("/api/v1/auth/independent/me")
    .then((res) => {
      saveIndependent(res.data.summary);
      return res.data.summary;
    })
    .catch(() => independent());
}
